// extracted by mini-css-extract-plugin
export default {"inner":"Browse_inner__IVbe5","head":"Browse_head__g+1Ow","info":"Browse_info__XKo8D","headSmall":"Browse_headSmall__OGeN6","wrapper":"Browse_wrapper__wVYK5"};